import { Phone } from "lucide-react";
import { SITE } from "../../data/site";

export const MobileCallBar = () => (
  <a
    href={SITE.phoneHref}
    data-testid="mobile-sticky-call"
    className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-[#C05746] text-[#F9F7F4] px-5 py-4 flex items-center justify-center gap-3 font-display text-lg tracking-tight shadow-[0_-10px_30px_rgba(0,0,0,0.15)] active:bg-[#A64B3C] transition-colors"
  >
    <span className="w-9 h-9 rounded-full bg-[#F9F7F4]/15 flex items-center justify-center">
      <Phone size={18} strokeWidth={2.5} />
    </span>
    <span className="flex flex-col items-start leading-none">
      <span className="text-[9px] uppercase tracking-[0.24em] opacity-80">
        Tap to call
      </span>
      <span className="text-lg">{SITE.phoneDisplay}</span>
    </span>
  </a>
);
